module.exports = __webpack_public_path__ + "img/dashboard-icon.b82b4035.svg";